var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3Dots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15057_7585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0L16 16L0 16L0 0L16 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15057_7585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 12.6667C16 13.4 15.4 14 14.6667 14C13.9333 14 13.3333 13.4 13.3333 12.6667C13.3333 11.9333 13.9333 11.3333 14.6667 11.3333C15.4 11.3333 16 11.9333 16 12.6667Z",
    fill: "#23262F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3.33073C16 4.06406 15.4 4.66406 14.6667 4.66406C13.9333 4.66406 13.3333 4.06406 13.3333 3.33073C13.3333 2.5974 13.9333 1.9974 14.6667 1.9974C15.4 1.9974 16 2.5974 16 3.33073Z",
    fill: "#23262F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.0026C16 8.73594 15.4 9.33594 14.6667 9.33594C13.9333 9.33594 13.3333 8.73594 13.3333 8.0026C13.3333 7.26927 13.9333 6.66927 14.6667 6.66927C15.4 6.66927 16 7.26927 16 8.0026Z",
    fill: "#23262F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Dots);
export default __webpack_public_path__ + "static/media/3-dots.9bcfd57c52150a47dce01e46da7ce6f6.svg";
export { ForwardRef as ReactComponent };